// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// import "firebase/firestore";
import { getAuth } from "firebase/auth";
import envJson from "../env.json";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: envJson.FIREBASE_API_KEY,
  authDomain: envJson.FIREBASE_AUTH_DOMAIN,
  databaseURL: envJson.FIREBASE_DATABASE_URL,
  projectId: envJson.FIREBASE_PROJECT_ID,
  storageBucket: envJson.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: envJson.FIREBASE_MESSAGING_SENDER_ID,
  appId: envJson.FIREBASE_APP_ID,
  measurementId: envJson.FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const analytics = getAnalytics(app);

const firebaseService = {
  firebaseApp: app,
  auth: auth,
  firebaseAnalytics: analytics,
};

export default firebaseService;
